import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/react-tweet/dist/hooks.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/react-tweet/dist/twitter-theme/quoted-tweet/quoted-tweet-container.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/react-tweet/dist/twitter-theme/tweet-actions-copy.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/react-tweet/dist/twitter-theme/tweet-media-video.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/components/adoption.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/components/heartbeat.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/components/inflation.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/components/liquidity.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/components/roi.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/components/shares.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BorderContainer"] */ "/vercel/path0/src/components/border-container.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Button"] */ "/vercel/path0/src/components/button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["chartXAxis","chartYAxis"] */ "/vercel/path0/src/components/chart-axes.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ChartBlock"] */ "/vercel/path0/src/components/chart-block.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ChartCard"] */ "/vercel/path0/src/components/chart-card.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ChartLegendToggleAll"] */ "/vercel/path0/src/components/chart-legend-toggle-all.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ChartScaleToggle"] */ "/vercel/path0/src/components/chart-scale-toggle.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ChartTable"] */ "/vercel/path0/src/components/chart-table.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ChartUnitToggle"] */ "/vercel/path0/src/components/chart-unit-toggle.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DashboardStats"] */ "/vercel/path0/src/components/dashboard-stats.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DataRefreshButton"] */ "/vercel/path0/src/components/data-refresh-button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DropdownMenu","DropdownMenuItem","DropdownMenuTrigger","DropdownMenuContent"] */ "/vercel/path0/src/components/dropdown.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Equation"] */ "/vercel/path0/src/components/equation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ExploreChartLegend"] */ "/vercel/path0/src/components/explore-chart-legend.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["exploreChartLines","ExploreChartLines"] */ "/vercel/path0/src/components/explore-chart-lines.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ExploreNav"] */ "/vercel/path0/src/components/explore-nav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GoPulseX"] */ "/vercel/path0/src/components/go-pulse-x.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Heading"] */ "/vercel/path0/src/components/heading.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LaunchTimeline"] */ "/vercel/path0/src/components/launch-timeline.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/vercel/path0/src/components/layout/footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Navbar"] */ "/vercel/path0/src/components/layout/navbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LiquidityPie"] */ "/vercel/path0/src/components/liquidity-pie.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MasonryGrid"] */ "/vercel/path0/src/components/masonry-grid.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MiniCard"] */ "/vercel/path0/src/components/mini-card.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PageHero"] */ "/vercel/path0/src/components/page-hero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Paragraph"] */ "/vercel/path0/src/components/paragraph.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PreviewLineChart"] */ "/vercel/path0/src/components/preview-line-chart.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProgressBar"] */ "/vercel/path0/src/components/progress-bar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Spinner"] */ "/vercel/path0/src/components/spinner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StatCard"] */ "/vercel/path0/src/components/stat-card.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SubHeading"] */ "/vercel/path0/src/components/sub-heading.tsx");
